module.exports = __webpack_public_path__ + "static/media/blogpost4.308cab87.png";